import { useNavigate } from "react-router-dom";
import "../styles/Cart.css";
import { useCartWishlist } from "../Context/CartWishlistContext";

const Cart = () => {
  const navigate = useNavigate();

  const {
    cartCourses,
    removeFromCart,
    addToWishlist,
    cartCount
  } = useCartWishlist();

  /* ===== Move item to wishlist ===== */
  const moveToWishlist = async (course) => {
    await addToWishlist(course);
    await removeFromCart(course.id);
    navigate("/wishlist");
  };

  /* ===== TOTAL CALCULATION ===== */
  const total = cartCourses.reduce((sum, item) => {
    const price =
      Number(item.discountedPrice) === 0
        ? Number(item.price || 0)
        : Number(item.discountedPrice || 0);

    const count = Number(item.count || 1);

    return sum + price * count;
  }, 0);

  return (
    <div className="cart-page">

      {/* LEFT SECTION */}
      <div className="cart-left">
        <h1>Shopping Cart</h1>
        {cartCourses.length === 0 && (
          <div className="empty-cart">
            <h3>Your cart is empty</h3>
            <button onClick={() => navigate("/courses")}>
              Browse Courses
            </button>
          </div>
        )}

        <div className="cart-grid">
          {cartCourses.map((course) => (
            <div className="cart-card" key={course.id}>
              
              {/* Clickable area */}
              <div
                className="cart-card-body"
                onClick={() =>
                  navigate(`/courses/${course.id}`)
                }
              >
                <img
                  src={course.thumbnail}
                  alt={course.title}
                />

                <div className="card-info">
                  <h3>{course.title}</h3>
                  <p>{course.instructor}</p>

                  {/* PRICE DISPLAY */}
                  <div className="price">
                    {Number(course.discountedPrice) > 0 ? (
                      <>
                        <span className="discounted">
                          ₹{course.discountedPrice}
                        </span>
                        <span className="original">
                          ₹{course.price}
                        </span>
                      </>
                    ) : (
                      <span className="discounted">
                        ₹{course.price}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="card-actions">
                <button
                  onClick={() =>
                    removeFromCart(course.id)
                  }
                >
                  Remove
                </button>

                <button
                  onClick={() =>
                    moveToWishlist(course)
                  }
                >
                  Move to Wishlist
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT PANEL */}
      {cartCourses.length > 0 && (
        <div className="cart-right">
          <h3>Total:</h3>
          <h1>₹{total}</h1>

          <button
            className="checkout-btn"
            onClick={() => navigate("/checkout")}
          >
            Proceed to Checkout →
          </button>
        </div>
      )}
    </div>
  );
};

export default Cart;
